export const DEFAULT_LANG_FILE: string = 'en';
export const DEFAULT_LANG_CODE: string = 'en-GB';
export const SUPPORTED_LANGUAGES: Array<string> = ['en', 'de', 'fr', 'es', 'zh'];

export interface ILanguage {
  code: string;
  country: string;
  flag: string;
  language: string;
  isSelected: boolean;
}

export interface ILangsResp {
  langs: Array<ILanguage>;
}
